<template>
  <v-col cols="12" style="position: relative">
    <v-row no-gutters class="pt-4 mb-3" align="center">
      <v-col
        cols="auto"
        :class="{
          'mr-3': true,
          'switcher-col': !isMain && !isFirst,
          'switcher-col-not-last': !isMain && !isLast,
          'switcher-col-first': isFirst,
        }"
      >
        <switcher-button :disable="!conditionalOperator" v-model="conditionalOperator" @input="emitGroup" />
      </v-col>
      <v-col cols="auto">
        <v-menu offset-y absolute>
          <template #activator="{ on }">
            <base-rounded-button
              v-on="on"
              class="new-filter-button"
              icon="mdi-plus"
              icon-color="rgba(32,33,36,0.67)"
              :custom-size="26"
              color="#eaeaf4"
            />
          </template>
          <v-list>
            <v-list-item style="min-height: 30px" @click="addNewExpression">
              <v-list-item-title class="text-item text-left text-subtitle-2 font-weight-regular">
                {{ $i18n.t('dialog.addCondition') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item style="min-height: 30px" @click="addNewGroup">
              <v-list-item-title class="text-item text-left text-subtitle-2 font-weight-regular">
                {{ $i18n.t('dialog.addGroup') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <base-rounded-button
          v-if="canDelete"
          class="new-filter-button"
          icon="mdi-close"
          icon-color="rgba(32,33,36,0.67)"
          :custom-size="26"
          color="#eaeaf4"
          @click="$emit('deleteGroup')"
        />
      </v-col>
      <template v-if="isMain">
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-tooltip bottom color="font" :disabled="!!value">
            <template #activator="{ on }">
              <span v-on="on">
                <base-button
                  style="right: -18px"
                  :disabled="!value"
                  translation-path="button.clearFilters"
                  @click="$emit('clearAllFilteres')"
                ></base-button>
              </span>
            </template>
            <div>
              {{ clearAllFilteresTooltip }}
            </div>
          </v-tooltip>
        </v-col>
      </template>
    </v-row>
    <template v-for="(expression, idx) in values">
      <v-row
        no-gutters
        class="ml-6 mb-4"
        :key="idx"
        v-if="expression && groupConditionalOperators.includes(Object.keys(expression)[0])"
      >
        <expression-group
          :data-source-name="dataSourceName"
          :data-source-attributes="dataSourceAttributes"
          :data-source-attributes-relational="dataSourceAttributesRelational"
          :is-last="idx === values.length - 1"
          :is-first="idx === 0"
          :can-delete="isMain ? values.length > 1 : values.length > 2"
          v-model="values[idx]"
          @input="emitGroup"
          @deleteGroup="deleteGroup(idx)"
        />
      </v-row>
      <v-row
        no-gutters
        :class="{
          expression: true,
          'ml-6': true,
          'expression-last': idx === values.length - 1,
        }"
        align="center"
        :key="idx"
        v-else
      >
        <v-col cols="11">
          <expression
            v-model="values[idx]"
            :data-source-name="dataSourceName"
            :data-source-attributes="dataSourceAttributes"
            :data-source-attributes-relational="dataSourceAttributesRelational"
            @input="emitGroup"
          />
        </v-col>
        <v-col cols="1">
          <v-icon
            small
            v-if="isMain ? values.length > 1 : values.length > 2"
            color="rgba(0,0,0,0.59)"
            style="cursor: pointer"
            @click="deleteExpression(idx)"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
    </template>
  </v-col>
</template>

<script>
import BaseButton from '@/components/BaseButton';
import Expression from '@/components/Expression';
import ExpressionGroup from '@/components/ExpressionGroup';
import SwitcherButton from '@/components/SwitcherButton';

export default {
  name: 'expression-group',
  components: {
    BaseButton,
    Expression,
    ExpressionGroup,
    SwitcherButton,
  },
  props: {
    dataSourceAttributes: {
      type: Array,
      required: true,
    },
    dataSourceAttributesRelational: {
      type: Array,
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      defaul: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    isMain: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    conditionalOperator: '',
    groupConditionalOperators: ['!AND', '!OR'],
    values: [],
  }),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    clearAllFilteresTooltip() {
      return this.$i18n.t('tooltips.toClearFilters');
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: 'readValues',
    },
  },
  methods: {
    emitGroup() {
      if (this.conditionalOperator) {
        const obj = {};
        obj[`${this.conditionalOperator}`] = this.values;
        this.computedValue = obj;
        // this.$emit('input', obj);
      } else {
        this.computedValue = this.values[0];
        // this.$emit('input', this.values[0]);
      }
    },
    deleteGroup(idx) {
      this.values.splice(idx, 1);
      if (this.values.length < 2) {
        this.conditionalOperator = '';
        this.computedValue = this.values[0];
      } else {
        const obj = {};
        obj[`${this.conditionalOperator}`] = this.values;
        this.computedValue = obj;
      }
    },
    addNewExpression() {
      this.values.push(undefined);
      if (!this.conditionalOperator) {
        this.conditionalOperator = '!AND';
      }
    },
    addNewGroup() {
      this.values.push({
        '!AND': [undefined, undefined],
      });
      if (!this.conditionalOperator) {
        this.conditionalOperator = '!AND';
      }
    },
    deleteExpression(idx) {
      this.values.splice(idx, 1);
      if (this.values.length < 2) {
        this.conditionalOperator = '';
        this.computedValue = this.values[0];
      } else {
        const obj = {};
        obj[`${this.conditionalOperator}`] = this.values;
        this.computedValue = obj;
      }
    },
    showFilter() {
      this.isFilterVisible = true;
    },
    readValues() {
      const conditionalOperator = this.value && Object.keys(this.value)[0];
      if (conditionalOperator && this.groupConditionalOperators.includes(conditionalOperator)) {
        this.conditionalOperator = conditionalOperator;
        this.values = JSON.parse(JSON.stringify(this.value[this.conditionalOperator]));
      } else {
        this.conditionalOperator = '';
        this.values = JSON.parse(JSON.stringify([this.value]));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.border-top {
  @include border(top, 1px);
}
.text-item {
  cursor: pointer;
}
.expression {
  background-color: rgba(234, 234, 244, 0.25);
  border: 0.6px solid rgba(0, 0, 0, 0.12);
  min-height: 60px;
  position: relative;
}
.expression::before {
  content: '';
  width: 15px;
  height: 43px;
  position: absolute;
  left: -15px;
  top: -13px;
  border-left: 1px dashed #bababa;
  border-bottom: 1px dashed #bababa;
}
.expression::after {
  content: '';
  width: 15px;
  height: 40px;
  position: absolute;
  left: -15px;
  top: 28px;
  border-left: 1px dashed #bababa;
}
.expression-last::after {
  border: none !important;
}
.switcher-col::before {
  content: '';
  width: 15px;
  height: 46px;
  position: absolute;
  left: -14px;
  top: -18px;
  border-left: 1px dashed #bababa;
  border-bottom: 1px dashed #bababa;
}
.switcher-col-first::before {
  content: '';
  width: 15px;
  height: 40px;
  position: absolute;
  left: -14px;
  top: -10px;
  border-left: 1px dashed #bababa;
  border-bottom: 1px dashed #bababa;
}
.switcher-col-not-last::after {
  content: '';
  width: 15px;
  height: 100%;
  position: absolute;
  left: -14px;
  top: 30px;
  border-left: 1px dashed #bababa;
}
::v-deep {
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
  }
  .v-list-item__title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
  }
  .v-input {
    font-size: 14px;
  }
  .v-input__slot {
    margin-bottom: 0;
  }
  .new-filter-button .v-icon {
    font-size: 18px;
  }
}
</style>
